import { type MetricField, type OrganicStatsField, UserDimension } from "../../gql-generated/types";

export const createFieldListWithDimensions = (
    dimensions: UserDimension[],
    fieldNames: MetricField[],
): OrganicStatsField[] =>
    fieldNames.flatMap((fieldName) => {
        if (dimensions.length > 0) {
            return dimensions.map((reportDimension) => ({ fieldName, reportDimension }));
        }

        return [{ fieldName, reportDimension: UserDimension.UserDimensionUnset }];
    });
